import { fallbackImageUrl as femaleFallbackImageUrl, config as configFemale } from './img/woman';
import { fallbackImageUrl as maleFallbackImageUrl, config as configMale } from './img/man';

export const CONFIG_FEMALE = {
    sourceConfig: configFemale,
    fallbackImageUrl: femaleFallbackImageUrl,
    alt: 'female',
};

export const CONFIG_MALE = {
    sourceConfig: configMale,
    fallbackImageUrl: maleFallbackImageUrl,
    alt: 'male',
};
